import { createFileRoute } from "@tanstack/react-router";

import { AppLayout } from "../components/layout";
import { NotFound } from "../pages/NotFound";
import { requireAuth, requireLegalAccepted, requireVerified } from "../utils/routeGuards";

export const Route = createFileRoute("/app")({
  beforeLoad: async ({ location }) => {
    requireAuth(location);
    await requireVerified(location);
    await requireLegalAccepted(location);
  },
  component: AppLayout,
  notFoundComponent: () => <NotFound />,
});
